import { i18n } from "@translations/i18n";
import { useFetchGeneric } from "itsf-ui-common";

const genericError = i18n.t("genericError");
const unauthorizedError = i18n.t("unauthorizedError");

export const useFetch = () => useFetchGeneric(genericError, unauthorizedError);
